var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDaskInsuranceButtonIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Insurance_Button_Icon",
    "data-name": "Insurance Button Icon",
    xmlns: "http://www.w3.org/2000/svg",
    height: "4.43rem",
    viewBox: "0 0 71.029 71.016",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Line",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3921",
    "data-name": "Path 3921",
    d: "M70.085,40.029,64.892,37.8c.018-.1.058-1.119.058-1.119s1.367,1.641,2.784.323l4.842-5.084a1.629,1.629,0,0,0-.16-2.371L38.522,2.357a1.613,1.613,0,0,0-2.026,0L21.372,14.6V3.614A1.614,1.614,0,0,0,19.758,2h-8.07a1.614,1.614,0,0,0-1.614,1.614V23.749L2.6,29.8a1.606,1.606,0,0,0-.126,2.4l4.842,4.842c1.335,1.282,2.755-.349,2.755-.349V71.4a1.614,1.614,0,0,0,1.614,1.614h48.42a1.723,1.723,0,0,0,.8-.213A24.085,24.085,0,0,0,73.02,51.934V44.479A4.837,4.837,0,0,0,70.085,40.029ZM13.3,5.228h4.842V17.217L13.3,21.137ZM8.594,33.744,6.026,31.178,37.517,5.686,69.025,30.968,66.4,33.723l-27.9-21.7a1.621,1.621,0,0,0-1.984,0Zm4.689.444L37.512,15.343,61.741,34.188c0,.032-.019,2.256-.019,2.256l-.978-.42a1.608,1.608,0,0,0-1.27,0l-9.343,4A4.841,4.841,0,0,0,47.2,44.479v7.455a24.089,24.089,0,0,0,7.96,17.854H45.582V48.806a1.614,1.614,0,0,0-1.614-1.614H31.056a1.614,1.614,0,0,0-1.614,1.614V69.788H13.3s-.016-35.568-.019-35.6Zm19.387,35.6V50.42h9.684V69.788ZM69.792,51.934a20.854,20.854,0,0,1-9.684,17.584,20.854,20.854,0,0,1-9.684-17.584V44.479A1.615,1.615,0,0,1,51.4,43l8.708-3.732L68.814,43a1.612,1.612,0,0,1,.978,1.483Z",
    transform: "translate(-1.994 -2)",
    fill: "#199b8b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3922",
    "data-name": "Path 3922",
    d: "M25.842,24.684A4.842,4.842,0,1,0,21,19.842,4.848,4.848,0,0,0,25.842,24.684Zm0-6.456a1.614,1.614,0,1,1-1.614,1.614A1.616,1.616,0,0,1,25.842,18.228Z",
    transform: "translate(9.676 5.982)",
    fill: "#81b830"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3923",
    "data-name": "Path 3923",
    d: "M44.034,30.607,38.7,37.268l-1.953-1.953A1.614,1.614,0,0,0,34.47,37.6L37.7,40.825a1.627,1.627,0,0,0,2.4-.134l6.456-8.07a1.614,1.614,0,1,0-2.521-2.014Z",
    transform: "translate(17.661 15.193)",
    fill: "#81b830"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaskInsuranceButtonIcon);
export default __webpack_public_path__ + "static/media/dask-insurance-button-icon.0e31f40aa0330e9ed5a6745a8e9f4e2c.svg";
export { ForwardRef as ReactComponent };